import { render, staticRenderFns } from "./staticMap.vue?vue&type=template&id=4345f646&scoped=true&"
import script from "./staticMap.vue?vue&type=script&lang=js&"
export * from "./staticMap.vue?vue&type=script&lang=js&"
import style0 from "./staticMap.vue?vue&type=style&index=0&id=4345f646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345f646",
  null
  
)

export default component.exports